import React, { Component, PropTypes } from 'react';
import SaveSearch from 'SaveSearch/SaveSearchWrapper.js';
import JobMailNew from 'JobMailNew/JobMailWrapper';
import JobMailOld from 'JobMailOld/JobMailWrapper';
import Variant from 'Variant/Variant';

class SavePanel extends Component {
  static propTypes = {
    authenticated: PropTypes.bool.isRequired
  }

  render() {
    if (this.props.authenticated) {
      return <SaveSearch prompt="Like this search?" description="Get new jobs for this search sent to your inbox." />;
    }

    return (
      <div>
        <Variant experiment={'a1080b1c-e7b9-4f10-9a61-aaa32fdedcda'} variation={0}>
          <JobMailOld prompt="Get new jobs for this search sent to your inbox" />
        </Variant>
        <Variant experiment={'a1080b1c-e7b9-4f10-9a61-aaa32fdedcda'} variation={1}>
          <JobMailNew prompt="Receive new jobs for this search by email" />
        </Variant>
      </div>
    );
  }
}

export default SavePanel;



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SavePanel/SavePanel.js
 **/